import src from "IMAGE";
export default { src, width: 1200, height: 350, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAMUlEQVR42i3KIQ4AIBADwToEIQGCOwyY+/8Pb0XFiDYrSQOBg4WJjYsmBw/fZ3gnegEoqAFtr1rIQAAAAABJRU5ErkJggg=="};
